import './assets/main.css'
import { connectWebSockets } from './plugins/websocket';

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './plugins/store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'

import { Button, Icon, Popup, Calendar } from 'vant'
import 'element-plus/dist/index.css'
import VueApexCharts from 'vue3-apexcharts'
// 修改 v-calendar 的导入方式
import VCalendar from 'v-calendar'
import 'v-calendar/style.css'

import 'vant/lib/index.css'

import './assets/main.css'

// i18n —— 初始化时按当前语言选 Element Plus 语言包。
// 切换语言走 setLocale()，内部 location.reload() 重新引导，保证一致。
import { currentLocale, t } from './plugins/utils/i18n'
const epLocale = currentLocale.value === 'en' ? en : zhCn

// 浏览器标签 title 跟随语言（切语言后 reload 会再次执行）
try { document.title = t('app_title') } catch (e) { /* ignore */ }

const app = createApp(App)

// 注册 Vant 组件
app.use(Button)
app.use(Icon)
app.use(Popup)
app.use(Calendar)
app.use(VueApexCharts)
// 修改 v-calendar 的注册方式
app.use(VCalendar, {})
connectWebSockets()

app.use(store)
app.use(router)
app.use(ElementPlus, {
  locale: epLocale,
})

// cohort-only 账号访问非 cohort 页面时自动跳转
router.beforeEach((to, from, next) => {
  const user = store.state.user
  if ((user?.sleepreport_display_mode === 'cohort') && !to.path.startsWith('/cohort') && !['/access-denied', '/field-dictionary'].includes(to.path) && to.path !== '/login' && !to.path.startsWith('/login')) {
    next('/cohort')
  } else {
    next()
  }
})

app.mount('#app')
